var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Lista"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 8.5H3C2.66848 8.5 2.35054 8.6317 2.11612 8.86612C1.8817 9.10054 1.75 9.41848 1.75 9.75V12C1.75 12.3315 1.8817 12.6495 2.11612 12.8839C2.35054 13.1183 2.66848 13.25 3 13.25H13C13.3315 13.25 13.6495 13.1183 13.8839 12.8839C14.1183 12.6495 14.25 12.3315 14.25 12V9.75C14.25 9.41848 14.1183 9.10054 13.8839 8.86612C13.6495 8.6317 13.3315 8.5 13 8.5ZM12.75 11.75H3.25V10H12.75V11.75ZM13 2.75H3C2.66848 2.75 2.35054 2.8817 2.11612 3.11612C1.8817 3.35054 1.75 3.66848 1.75 4V6.25C1.75 6.58152 1.8817 6.89946 2.11612 7.13388C2.35054 7.3683 2.66848 7.5 3 7.5H13C13.3315 7.5 13.6495 7.3683 13.8839 7.13388C14.1183 6.89946 14.25 6.58152 14.25 6.25V4C14.25 3.66848 14.1183 3.35054 13.8839 3.11612C13.6495 2.8817 13.3315 2.75 13 2.75ZM12.75 6H3.25V4.25H12.75V6Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.aa4e81d3df7b17f94c897539cac06c89.svg";
export { ForwardRef as ReactComponent };